module.exports = __webpack_public_path__ + "img/中雪.e5ccb8a4.png";